/**
 * Per bond-type attorney step config (Phase 14 — bond creation wizard).
 * Preserves legacy behavior differences across probate / VA / trustee / guardianship.
 */

/** Surface flags for attorney hooks and section bases (Phase 9.10B). */
export const ATTORNEY_SURFACE_CONFIG = {
  creation: {
    surface: "creation",
    fuzzyMatchLocation: true,
    hydrateDialogStateFromData: false,
    exposeNavigate: false,
  },
  historic: {
    surface: "historic",
    fuzzyMatchLocation: true,
    hydrateDialogStateFromData: false,
    exposeNavigate: false,
  },
  retrieval: {
    surface: "retrieval",
    fuzzyMatchLocation: false,
    hydrateDialogStateFromData: true,
    exposeNavigate: true,
  },
};

export function getAttorneySurfaceConfig(surface) {
  return ATTORNEY_SURFACE_CONFIG[surface] || ATTORNEY_SURFACE_CONFIG.creation;
}

/** Guardian-level attorney section UI helpers (Phase 9.10B). */
export function getAttorneyCardTitle(attorneyUi) {
  return attorneyUi === "guardianship" || attorneyUi === "probate"
    ? "Selected Attorney Details:"
    : "Selected Attorney:";
}

export function getAttorneyOfficeAddressLabel(attorneyUi) {
  return attorneyUi === "va" ? "Address" : "Office Address";
}

export function getAttorneyHomeStepLabel(attorneyUi) {
  if (attorneyUi === "guardianship") return "Step 1: Address Information";
  if (attorneyUi === "trustee") return "Step 2: Address Information";
  if (attorneyUi === "probate") return "Step 2: Address Information";
  return null;
}

export function getAttorneyHomeFieldsLabel(attorneyUi) {
  if (attorneyUi === "guardianship") return "Step 2: Enter Home Address:";
  if (attorneyUi === "probate") return "Enter Home Address:";
  return null;
}

export const ATTORNEY_INFO_CONFIG = {
  probate: {
    attorneyInvolvedDefault: "Yes",
    attorneyInvolvedMutable: false,
    showAttorneyInvolvedToggle: false,
    pgAutoSetToNo: false,
    guestAttorneyInvolved: "Yes",
    guestFieldsFromGlobalData: false,
    guestFormWhenGuestOnly: true,
    showAutocompleteErrors: true,
    lawFirmUserSetsAttorneyYes: false,
    clearRelatedOnLawFirmCreate: true,
    fetchLawFirmsWhenGuest: false,
    radioValueFromData: false,
    useDebouncedAttorneySearch: true,
  },
  va: {
    attorneyInvolvedDefault: "No",
    attorneyInvolvedMutable: true,
    showAttorneyInvolvedToggle: true,
    showToggleOnlyWhenNotGuest: false,
    pgAutoSetToNo: true,
    guestAttorneyInvolved: "No",
    guestFieldsFromGlobalData: true,
    guestFormWhenGuestOnly: false,
    guestFormRequiresAttorneyYes: true,
    showAutocompleteErrors: false,
    lawFirmUserSetsAttorneyYes: false,
    clearRelatedOnLawFirmCreate: false,
    fetchLawFirmsWhenGuest: false,
    radioValueFromData: true,
    useDebouncedAttorneySearch: true,
  },
  trustee: {
    attorneyInvolvedDefault: "Yes",
    attorneyInvolvedMutable: true,
    showAttorneyInvolvedToggle: true,
    showToggleOnlyWhenNotGuest: true,
    pgAutoSetToNo: true,
    guestAttorneyInvolved: "Yes",
    guestFieldsFromGlobalData: true,
    guestFormWhenGuestOnly: true,
    showAutocompleteErrors: false,
    lawFirmUserSetsAttorneyYes: true,
    clearRelatedOnLawFirmCreate: false,
    fetchLawFirmsWhenGuest: false,
    radioValueFromData: true,
    useDebouncedAttorneySearch: true,
  },
  guardianship: {
    attorneyInvolvedDefault: "Yes",
    attorneyInvolvedMutable: true,
    showAttorneyInvolvedToggle: true,
    showToggleOnlyWhenNotGuest: true,
    pgAutoSetToNo: true,
    guestAttorneyInvolved: "Yes",
    guestFieldsFromGlobalData: false,
    guestFormWhenGuestOnly: true,
    showAutocompleteErrors: false,
    lawFirmUserSetsAttorneyYes: false,
    clearRelatedOnLawFirmCreate: false,
    fetchLawFirmsWhenGuest: false,
    radioValueFromData: false,
    useDebouncedAttorneySearch: true,
  },
};
